import { FieldType } from '../../models/form/fieldType';
import { StepModel } from './../../models/form/step';

export const mockStepCase1: StepModel = {
  id: 'step-id',
  name: 'My first Step',
  sections: [
    {
      id: 'section-1',
      name: 'My first section',
      multiple: false,
      visible: true,
      fields: [
        {
          size: 6,
          id: 'firstname-id',
          text: 'First Name',
          defaultValue: 'Alex',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          minLength: 4,
          maxLength: 10,
          excludeFromReport: false,
          placeholder: '',
        },
        {
          size: 6,
          id: 'lastname-id',
          text: 'Last Name',
          defaultValue: 'Caissy',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          minLength: 4,
          maxLength: 10,
          excludeFromReport: false,
          placeholder: '',
        },
        {
          size: 4,
          id: 'numeric-id',
          text: 'Numeric Field',
          defaultValue: 33,
          type: FieldType.Numeric,
          decimals: undefined,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: '',
          min: 0,
          max: 1000,
          excludeFromReport: false,
        },
        {
          size: 8,
          id: 'email-id',
          text: 'Email Field',
          defaultValue: 'petit-email@kreezee.com',
          type: FieldType.EmailAddress,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
          placeholder: 'example@gmail.com',
          sendReceipt: false,
        },
        {
          size: 12,
          id: 'static-id',
          text: 'Static Text',
          defaultValue: undefined,
          value:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          type: FieldType.StaticText,
          required: false,
          hiddenText: false,
          textColor: 'black',
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'longtext-id',
          text: 'Long Text Field',
          defaultValue:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard d',
          type: FieldType.LongText,
          required: true,
          hiddenText: false,
          textColor: 'blue',
          enabled: true,
          visible: true,
          excludeFromReport: false,
          placeholder: 'Describe...',
          minLength: undefined,
          maxLength: undefined,
        },
        {
          size: 6,
          id: 'date-id',
          text: 'Date Field',
          defaultValue: '03-12-1994',
          type: FieldType.Date,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'Select a date',
          excludeFromReport: false,
        },
        {
          size: 6,
          id: 'birthdate-id',
          text: 'Birthdate Field',
          defaultValue: '03-12-1994',
          type: FieldType.Birthdate,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: '',
          excludeFromReport: false,
        },
        {
          size: 6,
          id: 'time-id',
          text: 'Time Field',
          defaultValue: '3h11',
          value: '',
          type: FieldType.Time,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'h:mm',
          excludeFromReport: false,
        },
        {
          size: 6,
          id: 'datetime-id',
          text: 'My Datetime',
          defaultValue: '03-12-1994 3h11',
          type: FieldType.Datetime,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'Select a date',
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'select-id',
          text: 'Select Field',
          defaultValue: 'cat',
          options: [
            { text: 'Option 1', value: 'dog' },
            { text: 'Option 2', value: 'cat' },
            { text: 'Option 3', value: 'pig' },
          ],
          type: FieldType.Select,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'Choisir une option',
          excludeFromReport: false,
        },
        {
          size: 4,
          id: 'weblink-id',
          text: 'Click here for more information',
          defaultValue: 'https://google.com',
          type: FieldType.WebLink,
          required: false,
          hiddenText: true,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          target: '_blank',
          excludeFromReport: false,
        },
        {
          size: 4,
          id: 'weblink2-id',
          text: 'Purple link',
          defaultValue: 'https://google.com',
          type: FieldType.WebLink,
          required: false,
          hiddenText: true,
          textColor: 'purple',
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          target: '_blank',
          excludeFromReport: false,
        },
        {
          size: 4,
          id: 'weblink3-id',
          text: 'Disabled link',
          defaultValue: 'https://google.com',
          type: FieldType.WebLink,
          required: false,
          hiddenText: true,
          textColor: 'undefined',
          enabled: false,
          visible: true,
          placeholder: 'placeholder',
          target: '_blank',
          excludeFromReport: false,
        },
        {
          size: 3,
          id: 'option-id',
          text: 'Option List Field (multiselect)',
          defaultValue: ['cat', 'pig'],
          options: [
            { text: 'Option 1', value: 'dog' },
            { text: 'Option 2', value: 'cat' },
            { text: 'Option 3', value: 'pig' },
          ],
          type: FieldType.OptionList,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          multiSelection: true,
          excludeFromReport: false,
        },
        {
          size: 3,
          id: 'option2-id',
          text: 'Option List Field',
          defaultValue: ['cat'],
          options: [
            { text: 'Option 1', value: 'dog' },
            { text: 'Option 2', value: 'cat' },
            { text: 'Option 3', value: 'pig' },
          ],
          type: FieldType.OptionList,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          multiSelection: false,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'checkbox-id',
          text: 'CheckBox Field',
          defaultValue: true,
          type: FieldType.CheckBox,
          required: true,
          hiddenText: true,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'toggle-id',
          text: 'Toggle Field',
          defaultValue: true,
          type: FieldType.Toggle,
          required: true,
          hiddenText: true,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'rating-id',
          text: 'My Rating',
          defaultValue: 3.5,
          type: FieldType.Rating,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          starColor: '#0141b7',
          count: 5,
          allowHalf: true,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'yesno-id',
          text: 'Do you like dogs?',
          defaultValue: 'no',
          type: FieldType.YesNo,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          allowNa: true,
          excludeFromReport: false,
        },
        {
          size: 7,
          id: 'html-id',
          text: 'HTML Field',
          defaultValue: undefined,
          value:
            '<h2>Beginning of HTML</h2><img style="width: 100%" src="https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png" /><h4 style="color: orange">End of HTML</h4>',
          type: FieldType.HTML,
          required: false,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 6,
          id: 'signature-id',
          text: 'Signature Field',
          defaultValue: undefined,
          type: FieldType.Signature,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'acknowledgment-id',
          text: 'Acknowledgment Field',
          defaultValue: true,
          type: FieldType.Acknowledgment,
          required: true,
          hiddenText: true,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'documentViewer-id',
          text: 'Document Viewer Field (word)',
          defaultValue: 'https://unit.kreezee.com/files/handler/82',
          documentName: 'wordtest',
          type: FieldType.DocumentViewer,
          required: false,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          documentType: 'doc',
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'documentViewer2-id',
          text: 'Document Viewer Field (pdf)',
          defaultValue: 'https://www.kreezee.com/files/handler/833',
          documentName: 'pdftest',
          type: FieldType.DocumentViewer,
          required: false,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          documentType: 'pdf',
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'documentViewer3-id',
          text: 'Document Viewer Field (excel)',
          defaultValue: 'https://unit.kreezee.com/files/handler/34',
          documentName: 'exceltest',
          type: FieldType.DocumentViewer,
          required: false,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          documentType: 'xlsx',
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'image-id',
          text: 'Image Field',
          defaultValue:
            'https://www2.aston.ac.uk/image-library/Sports/homepage-image-banner/sports%20banner%20football.jpg',
          type: FieldType.EmbeddedPhoto,
          required: false,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          alt: 'soccer banner',
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'video-id',
          text: 'Video Field',
          defaultValue: 'https://www.youtube.com/embed/QPdyuyPLhFk',
          type: FieldType.Video,
          required: false,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          videoPlayer: 'youtube',
          excludeFromReport: false,
        },
      ],
    },
    {
      id: 'section2-id',
      name: 'My Second section',
      multiple: true,
      visible: true,
      multipleValidations: {
        min: 1,
        max: 3,
      },
      fields: [
        {
          size: 8,
          id: 'firstname4442-id',
          text: 'First Name',
          defaultValue: 'Georde',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 4,
          maxLength: 10,
          excludeFromReport: false,
        },
        {
          size: 4,
          id: 'lastname4442-id',
          text: 'Last Name',
          defaultValue: 'Baracque',
          type: FieldType.Text,
          required: false,
          hiddenText: false,
          textColor: '',
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 4,
          maxLength: 10,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'toggle2444-id',
          text: 'My Toggle',
          defaultValue: true,
          type: FieldType.Toggle,
          required: true,
          hiddenText: true,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
      ],
    },
  ],
};

export const mockStepCase2: StepModel = {
  id: 'Step1',
  name: 'My second Step',
  sections: [
    {
      id: 'Section1',
      name: 'My first section',
      multiple: false,
      visible: true,
      fields: [
        {
          size: 12,
          id: 'static-id111',
          text: '',
          value: 'Case 1: Actions',
          defaultValue: undefined,
          type: FieldType.StaticText,
          required: false,
          hiddenText: true,
          textColor: 'blue',
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 8,
          id: 'check1',
          text: 'Show visible',
          defaultValue: false,
          type: FieldType.CheckBox,
          required: true,
          hiddenText: true,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'text1',
          text: 'First Name',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 0,
          maxLength: 20,
          excludeFromReport: false,
        },
        {
          size: 8,
          id: 'check2',
          text: 'Put required',
          defaultValue: false,
          type: FieldType.CheckBox,
          required: false,
          hiddenText: true,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'text2',
          text: 'First Name',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 0,
          maxLength: 20,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'static-id1',
          text: '',
          value: 'Case 2: Other Conditions',
          defaultValue: undefined,
          type: FieldType.StaticText,
          required: false,
          hiddenText: true,
          textColor: 'blue',
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'text-2',
          text: 'Type "salut" (IsEqual)',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 0,
          maxLength: 20,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'text-2-1',
          text: 'TADA!',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 0,
          maxLength: 20,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'text-2-3',
          text: 'Greater than 10 (GreaterThan)',
          defaultValue: undefined,
          type: FieldType.Numeric,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          decimals: 0,
          min: undefined,
          max: undefined,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'text-2-1-3',
          text: 'TADA!',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 0,
          maxLength: 20,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'static-id3',
          text: '',
          value: 'Case 3: Multiple sections',
          defaultValue: undefined,
          type: FieldType.StaticText,
          required: false,
          hiddenText: true,
          textColor: 'blue',
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
      ],
    },
    {
      id: 'SectionMultiple2',
      name: 'My first section',
      multiple: true,
      multipleValidations: {
        min: 2,
        max: 5,
      },
      visible: true,
      fields: [
        {
          size: 8,
          id: 'check1-mul',
          text: 'Show visible',
          defaultValue: false,
          type: FieldType.CheckBox,
          required: false,
          hiddenText: true,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'text1-mul',
          text: 'First Name',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 0,
          maxLength: 20,
          excludeFromReport: false,
        },
        {
          size: 8,
          id: 'check2-mul',
          text: 'Put required',
          defaultValue: false,
          type: FieldType.CheckBox,
          required: false,
          hiddenText: true,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'text2-mul',
          text: 'First Name',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 0,
          maxLength: 20,
          excludeFromReport: false,
        },
      ],
    },
    {
      id: 'Section3',
      name: 'My first section',
      multiple: false,
      visible: true,
      fields: [
        {
          size: 12,
          id: 'static-id4',
          text: '',
          value: 'Case 4: Nested Rules',
          defaultValue: undefined,
          type: FieldType.StaticText,
          required: false,
          hiddenText: true,
          textColor: 'blue',
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 8,
          id: 'check3',
          text: 'Show visible',
          defaultValue: false,
          type: FieldType.CheckBox,
          required: false,
          hiddenText: true,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 8,
          id: 'check3-1',
          text: 'Show visible again',
          defaultValue: false,
          type: FieldType.CheckBox,
          required: false,
          hiddenText: true,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'text3',
          text: 'First Name',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 0,
          maxLength: 20,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'static-id5',
          text: '',
          value: 'Case 5: Logical AND/OR',
          defaultValue: undefined,
          type: FieldType.StaticText,
          required: false,
          hiddenText: true,
          textColor: 'blue',
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 8,
          id: 'check4-1',
          text: 'Check this box AND',
          defaultValue: false,
          type: FieldType.CheckBox,
          required: false,
          hiddenText: true,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 8,
          id: 'check4-2',
          text: 'This box',
          defaultValue: false,
          type: FieldType.CheckBox,
          required: false,
          hiddenText: true,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'static-id5-1',
          text: '',
          value: 'OR',
          defaultValue: undefined,
          type: FieldType.StaticText,
          required: false,
          hiddenText: true,
          textColor: 'black',
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 8,
          id: 'check4-3',
          text: 'This box',
          defaultValue: false,
          type: FieldType.CheckBox,
          required: false,
          hiddenText: true,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'text5',
          text: 'Tada!',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 0,
          maxLength: 20,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'static-id6',
          text: '',
          value: 'Case 6: Multiple targets',
          defaultValue: undefined,
          type: FieldType.StaticText,
          required: false,
          hiddenText: true,
          textColor: 'blue',
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 8,
          id: 'check6',
          text: 'Multiple targets',
          defaultValue: false,
          type: FieldType.CheckBox,
          required: false,
          hiddenText: true,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'text6-1',
          text: 'Text 6 - 1',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 0,
          maxLength: 20,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'text6-2',
          text: 'Text 6 - 2',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 0,
          maxLength: 20,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'static-id3',
          text: '',
          value: 'Case 7: Multiple sections with outside condition',
          defaultValue: undefined,
          type: FieldType.StaticText,
          required: false,
          hiddenText: true,
          textColor: 'blue',
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 8,
          id: 'check7',
          text: 'Check this box',
          defaultValue: false,
          type: FieldType.CheckBox,
          required: false,
          hiddenText: true,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
      ],
    },
    {
      id: 'SectionMultiple4',
      name: 'My first section',
      multiple: true,
      visible: true,
      fields: [
        {
          size: 8,
          id: 'check4-mul',
          text: 'Check this AND the outside checkbox',
          defaultValue: false,
          type: FieldType.CheckBox,
          required: false,
          hiddenText: true,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: 'text4-mul',
          text: 'First Name',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 0,
          maxLength: 20,
          excludeFromReport: false,
        },
      ],
    },
  ],
};

export const mockStepCase3: StepModel = {
  id: 'step-3',
  name: 'My third Step',
  sections: [
    {
      id: 'section-id',
      name: 'My first section',
      multiple: false,
      visible: true,
      fields: [
        {
          size: 12,
          id: '161fa424-5a17-4f44-b046-cc3ef2e2540-1',
          text: 'First Name',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 0,
          maxLength: 20,
          excludeFromReport: false,
        },
        {
          size: 12,
          id: '161fa424-5a17-4f44-b046-cc3ef2e2540-2',
          text: 'Last Name',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 4,
          maxLength: 10,
          excludeFromReport: false,
        },
        {
          size: 4,
          id: '161fa424-5a17-4f44-b046-cc3ef2e2540-3',
          text: 'Age',
          defaultValue: undefined,
          type: FieldType.Numeric,
          decimals: undefined,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          min: 0,
          max: 1000000000000,
          excludeFromReport: false,
        },
        {
          size: 8,
          id: '161fa424-5a17-4f44-b046-cc3ef2e2540-4',
          text: 'Date de naissance',
          defaultValue: '',
          type: FieldType.Birthdate,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          excludeFromReport: false,
        },
        {
          size: 12,
          id: '161fa424-5a17-4f44-b046-cc3ef2e2540-pay9',
          text: 'Choix de chandail',
          defaultValue: [],
          type: FieldType.PaymentOptionList,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
          options: [
            {
              value: '161fa424-5a17-4f44-b046-cc3ef2e2540-opt01',
              text: 'Chandail small',
              price: 1099,
              description: 'Un chandail small',
            },
          ],
        },
        {
          size: 12,
          id: '161fa424-5a17-4f44-b046-cc3ef2e2540-pay10',
          text: 'Choix de chandail',
          defaultValue: [],
          type: FieldType.PaymentChoiceList,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
          choices: [
            {
              value: '161fa424-5a17-4f44-b046-cc3ef2e2540-opt02',
              text: 'Chandail medium',
              price: 1099,
              description: '',
            },
            {
              value: '161fa424-5a17-4f44-b046-cc3ef2e2540-opt03',
              text: 'Chandail large',
              price: 1099,
              description: 'Un beau chandail large',
            },
          ],
        },
      ],
    },
  ],
};

export const mockStepCase4: StepModel = {
  id: 'step-4',
  name: 'My fourth Step',
  sections: [
    {
      id: 'section-id',
      name: 'My first section',
      multiple: false,
      visible: true,
      fields: [
        {
          size: 12,
          id: '161fa424-5a17-4f44-b046-cc3ef2e2540-5',
          text: 'Address',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 1,
          maxLength: 80,
          excludeFromReport: false,
        },
        {
          size: 6,
          id: '161fa424-5a17-4f44-b046-cc3ef2e2540-6',
          text: 'City',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 1,
          maxLength: 80,
          excludeFromReport: false,
        },
        {
          size: 4,
          id: '161fa424-5a17-4f44-b046-cc3ef2e2540-7',
          text: 'Country',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 1,
          maxLength: 80,
          excludeFromReport: false,
        },
        {
          size: 8,
          id: '161fa424-5a17-4f44-b046-cc3ef2e2540-8',
          text: 'Continent',
          defaultValue: '',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 1,
          maxLength: 80,
          excludeFromReport: false,
        },
      ],
    },
  ],
};

export const mockStepCase5: StepModel = {
  id: 'step-5',
  name: 'Un tres long nom de section pour fairte un tres long test',
  sections: [
    {
      id: 'section-id',
      name: 'My first section',
      multiple: false,
      visible: true,
      fields: [
        {
          size: 12,
          id: '161fa424-5a17-4f44-b046-cc3ef2e2540-9',
          text: 'Email',
          defaultValue: '',
          type: FieldType.EmailAddress,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          excludeFromReport: false,
          sendReceipt: false,
        },
        {
          size: 12,
          id: '161fa424-5a17-4f44-b046-cc3ef2e2540-10',
          text: "Je consens l'envoi de ces informations de feu",
          defaultValue: false,
          type: FieldType.Acknowledgment,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          excludeFromReport: false,
        },
      ],
    },
    {
      id: 'multiple-id',
      name: 'My Second section',
      multiple: true,
      visible: true,
      multipleValidations: {
        min: 1,
        max: 3,
      },
      fields: [
        {
          size: 8,
          id: 'firstname',
          text: 'First Name',
          defaultValue: 'Georde',
          type: FieldType.Text,
          required: true,
          hiddenText: false,
          textColor: undefined,
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 4,
          maxLength: 10,
          excludeFromReport: false,
        },
        {
          size: 4,
          id: 'lastname',
          text: 'Last Name',
          defaultValue: 'Baracque',
          type: FieldType.Text,
          required: false,
          hiddenText: false,
          textColor: '',
          enabled: true,
          visible: true,
          placeholder: 'placeholder',
          minLength: 4,
          maxLength: 10,
          excludeFromReport: false,
        },
      ],
    },
  ],
};

export const multistepMock: StepModel[] = [mockStepCase3, mockStepCase4, mockStepCase5];
